import { css } from "@emotion/react";

export const fonts = css`
    @font-face {
        font-family: "NVIDIA";
        src: url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Lt.woff)
                format("woff"),
            url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Lt.woff2)
                format("woff2");
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA";
        src: url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Rg.woff)
                format("woff"),
            url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Rg.woff2)
                format("woff2");
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA";
        src: url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Md.woff)
                format("woff"),
            url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Md.woff2)
                format("woff2");
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA";
        src: url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Bd.woff)
                format("woff"),
            url(https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/GLOBAL/NVIDIASans_W_Bd.woff2)
                format("woff2");
        font-weight: 700;
        font-style: normal;
    }

    @font-face {
        font-family: "NVIDIA-NALA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Lt.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Lt.woff2")
                format("woff2");
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-NALA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Rg.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Rg.woff2")
                format("woff2");
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-NALA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Md.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Md.woff2")
                format("woff2");
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-NALA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Bd.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/NALA/NVIDIASans_NALA_W_Bd.woff2")
                format("woff2");
        font-weight: 700;
        font-style: normal;
    }
    /* EMEA */
    @font-face {
        font-family: "NVIDIA-EMEA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Lt.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Lt.woff2")
                format("woff2");
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-EMEA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Rg.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Rg.woff2")
                format("woff2");
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-EMEA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Md.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Md.woff2")
                format("woff2");
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-EMEA";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Bd.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/EMEA/NVIDIASans_EMEA_W_Bd.woff2")
                format("woff2");
        font-weight: 700;
        font-style: normal;
    }
    /* RU */
    @font-face {
        font-family: "NVIDIA-RU";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Lt.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Lt.woff2")
                format("woff2");
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-RU";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Rg.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Rg.woff2")
                format("woff2");
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-RU";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Md.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Md.woff2")
                format("woff2");
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-RU";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Bd.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/RU/NVIDIASans_CYR_W_Bd.woff2")
                format("woff2");
        font-weight: 700;
        font-style: normal;
    }
    /* APAC */
    @font-face {
        font-family: "NVIDIA-APAC";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff2")
                format("woff2");
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-APAC";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff2")
                format("woff2");
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-APAC";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff2")
                format("woff2");
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-APAC";
        src: url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff")
                format("woff"),
            url("https://images.nvidia.com/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff2")
                format("woff2");
        font-weight: 700;
        font-style: normal;
    }
    /* CN */
    @font-face {
        font-family: "NVIDIA-CN";
        src: url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff")
                format("woff"),
            url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Lt.woff2")
                format("woff2");
        font-weight: 300;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-CN";
        src: url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff")
                format("woff"),
            url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Rg.woff2")
                format("woff2");
        font-weight: 400;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-CN";
        src: url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff")
                format("woff"),
            url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Md.woff2")
                format("woff2");
        font-weight: 500;
        font-style: normal;
    }
    @font-face {
        font-family: "NVIDIA-CN";
        src: url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff")
                format("woff"),
            url("https://images.nvidia.cn/etc/designs/nvidiaGDC/clientlibs_base/fonts/nvidia-sans/APAC/NVIDIASans_APAC_W_Bd.woff2")
                format("woff2");
        font-weight: 700;
        font-style: normal;
    }
`;
